module.exports = __webpack_public_path__ + "static/media/line-chart-new.29c64fae.png";